export default "__VITE_ASSET__26dae4ce__"